module.exports = require("isarray");